export const APP_NAME = 'INTRANET '
export const PERSIST_STORE_NAME = 'intranet-app'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const APP_XUSER_CODE = 'P-AMS'